// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 문의사항 관리 페이지 레이아웃 */
.qna-management-layout {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background: #f5f7fb;
}

.qna-management-layout main.qna-management-content {
  display: block;
  flex: 1 1;
  min-width: 0;
  height: auto;
  padding: 20px 28px 24px;
  box-sizing: border-box;
  color: #26354a;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminQna.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,+CAA+C;AACjD","sourcesContent":["/* 문의사항 관리 페이지 레이아웃 */\n.qna-management-layout {\n  display: flex;\n  width: 100%;\n  min-height: 100vh;\n  background: #f5f7fb;\n}\n\n.qna-management-layout main.qna-management-content {\n  display: block;\n  flex: 1;\n  min-width: 0;\n  height: auto;\n  padding: 20px 28px 24px;\n  box-sizing: border-box;\n  color: #26354a;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
